import React from 'react';

import {
    FormControl,
    MenuItem,
    Select,
    InputLabel,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const DropDownMenu = ({
    defaultLabel = 'Todos',
    defaultValue,
    handleSelected,
    itemsToSelect,
}) => {
    return (
        <FormControl fullWidth size="small" sx={{ minWidth: 200 }}>
            <InputLabel>{defaultLabel}</InputLabel>
            <Select
                label={defaultLabel}
                onChange={(e) => handleSelected(e.target)}
                value={defaultValue}
                variant="standard"
            >
                {itemsToSelect.map(({ disabled, label, value }) => (
                    <MenuItem
                        disabled={disabled}
                        key={`${value}-${label}`}
                        value={value}
                    >
                        {label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

DropDownMenu.propTypes = {
    defaultLabel: PropTypes.string,
    defaultValue: PropTypes.string,
    handleSelected: PropTypes.func,
    itemsToSelect: PropTypes.array,
};

export default DropDownMenu;
